<section class="auth-container">
  <!-- Offline Alert -->
  @if (!isOnline) {
    <div class="offline-banner">
      <mat-icon>wifi_off</mat-icon>
      <span>You appear to be offline. Please check your connection.</span>
    </div>
  }

  <div class="auth-content">
    <!-- Left Side - Form -->
    <div class="auth-form-section">
      <div class="auth-card">
        <!-- Logo & Header -->
        <div class="auth-header">
          <img ngSrc="../../../assets/img/brand/salesmax.png" width="2251" height="559" priority
            class="auth-logo" alt="Salesmax.ai" />
          <h1 class="auth-title">Welcome to Salesmax</h1>
          <p class="auth-subtitle">Create your account to get started</p>
        </div>

        <!-- Coming from Failed Sign In Alert -->
        @if (isComingFromFailedSignIn) {
          <div class="alert-message">
            <mat-icon>info</mat-icon>
            <span>Looks like you haven't signed up yet. Let's create your account!</span>
          </div>
        }

        <!-- Sign Up Form -->
        <form class="auth-form" [formGroup]="signUpForm">
          <div class="form-group">
            <label class="form-label">Full Name</label>
            <input
              class="form-input"
              formControlName="fullName"
              name="name"
              autocomplete="name"
              type="text"
              placeholder="John Doe">
          </div>

          <div class="form-group">
            <label class="form-label">Business Email</label>
            <input
              class="form-input"
              formControlName="email"
              name="email"
              autocomplete="email"
              type="email"
              placeholder="john.doe@company.com">
          </div>

          <div class="form-group">
            <label class="form-label">Phone Number</label>
            <ngx-intl-tel-input
              [cssClass]="'phone-input'"
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
              [selectFirstCountry]="false"
              [selectedCountryISO]="CountryISO.India"
              [maxLength]="15"
              [phoneValidation]="true"
              [separateDialCode]="separateDialCode"
              [numberFormat]="PhoneNumberFormat.National"
              name="phone"
              formControlName="sms">
            </ngx-intl-tel-input>
          </div>

          <button
            class="auth-button"
            type="button"
            (click)="signup()"
            [disabled]="(busy | async) || !(signUpForm.valid && signUpForm.controls['sms'].valid && signUpForm.controls['sms'].value !='' && signUpForm.controls['sms'].value != null)">
            @if (!(busy | async)) {
              <span>Request OTP</span>
            }
            @if (busy | async) {
              <mat-spinner [diameter]="24"></mat-spinner>
            }
          </button>

          @if (errorMessage | async) {
            <div class="error-message">
              <mat-icon>error_outline</mat-icon>
              <span>{{ errorMessage | async }}</span>
            </div>
          }
        </form>

        <!-- Footer Links -->
        <div class="auth-footer">
          <p class="footer-text">
            Already have an account?
            <a routerLink='/sign-in' routerLinkActive="active" class="footer-link">Sign In</a>
          </p>
        </div>
      </div>
    </div>

    <!-- Right Side - Illustration -->
    <div class="auth-illustration-section">
      <div class="illustration-content">
        <img ngSrc="assets/img/backgrounds/sign-up.svg" width="615" height="607" alt="Sign up illustration" priority>
        <h2 class="illustration-title">Start Growing Today</h2>
        <p class="illustration-text">Join thousands of businesses using Salesmax to streamline their sales process</p>
      </div>
    </div>
  </div>
</section>
